module.exports = __webpack_public_path__ + "static/media/Cross.17dc1405.png";